import { Currency } from '../General/Currency';
import { PaymentMethod } from '../General/PaymentMethod';
import { Technician } from '../General/Technician';

export enum SERVICE_ORDER_STATUS {
  PENDIENTE_DE_COORDINACION = 0,
  COORDINADA = 1,
  REALIZADA = 2,
  PENDIENTE_DE_FACTURACION = 3,
  FINALIZADA = 4,
  CANCELADO = 5,
}

const ServiceOrderStatusString = {
  [SERVICE_ORDER_STATUS.PENDIENTE_DE_COORDINACION]: 'Pendiente de coordinación',
  [SERVICE_ORDER_STATUS.COORDINADA]: 'Coordinada',
  [SERVICE_ORDER_STATUS.REALIZADA]: 'Realizada',
  [SERVICE_ORDER_STATUS.PENDIENTE_DE_FACTURACION]: 'Pendiente de facturación',
  [SERVICE_ORDER_STATUS.FINALIZADA]: 'Finalizada',
  [SERVICE_ORDER_STATUS.CANCELADO]: 'Cancelada',
};

// Brasil no factura al cliente desde esta pantalla: ese mismo estado representa
// que la orden quedó esperando el pago (al técnico y/o del cliente).
export const getServiceOrderStatusString = (
  status: SERVICE_ORDER_STATUS,
  isBrasilSelected: boolean,
): string =>
  isBrasilSelected && status === SERVICE_ORDER_STATUS.PENDIENTE_DE_FACTURACION
    ? 'Pendiente de pago'
    : ServiceOrderStatusString[status];

export enum SERVICE_ORDER_TYPE {
  INSTALACION = 0,
  SERVICIO_TECNICO = 1,
}
export const ServiceOrderTypeString = {
  [SERVICE_ORDER_TYPE.INSTALACION]: 'Instalación de OV cerrada',
  [SERVICE_ORDER_TYPE.SERVICIO_TECNICO]: 'Servicio Técnico',
};

export interface ServiceOrder {
  id: number;
  service_date: string;
  description: string;
  company: number;
  technician: number | Technician;
  moviles?: number[];
  contact_data?: string;
  aditional_comment?: string;
  status: SERVICE_ORDER_STATUS;
  type: SERVICE_ORDER_TYPE;
  kilometres_estimated?: number;
  hours_estimated?: number;
  technician_pay: boolean;
  customer_invoice: boolean;
  hours_covered?: number;
  kilometres_covered?: number;
  billing_order?: number;
  tickets?: number[];
  kilometres_to_pay?: number;
  hours_to_pay?: number;
  odoo_purchase_order?: number;
  created_at: string;
  updated_at: string;
  created_by?: number;
  hourly_rate?: number;
  kilometres_rate?: number;
  // Precio fijo de mano de obra para Instalación (ARG, casos nuevos): reemplaza
  // precio por hora + horas cuando la orden todavía no tenía datos de facturación.
  instalation_price?: number;
  currency?: Currency;
  created_automatically?: boolean;
  delivery_note_links?: string[];
  billing_numbers?: string;
  billing_numbers_to_client?: string;
  payment_method?: PaymentMethod;
  payment_method_client?: PaymentMethod;

  // Nota Fiscal (Brasil) – URL del PDF emitido por el técnico
  bill_file?: string | null;

  // Atributos del response de edición
  receptions_created?: number[];

  // Chequeo de revision de stock (logística)
  stock_technician_reviewed?: boolean;

  // Chequeo de recepción pendiente
  has_receptions_pending?: boolean;

  // Link público para técnico
  public_token?: string | null;
  public_token_used_at?: string | null;
  technician_confirmed?: boolean | null;
  technician_response?: string;
  technician_responded_at?: string | null;

  // Conversión DOL → ARS (solo cuando currency.abreviacion === "DOL" y el técnico confirmó)
  dollar_quote_used?: number | null;
  technician_payment_ars?: number | null;
}
